import {ValueObject} from '@s-ui/domain'

import {GetSuggestionsAssistantError} from '../Errors/GetSuggestionsAssistantError.js'

export class GetSuggestionsAssistantRequest extends ValueObject {
  #type
  #chatId
  #adId

  constructor({type, chatId, adId}) {
    super()
    this.#type = type
    this.#chatId = chatId
    this.#adId = adId
  }

  static create({type, chatId, adId}, {config}) {
    const {NET_SUGGESTION_TYPE} = config.get('COMMON').AI_ASSISTANT
    const validTypes = Object.values(NET_SUGGESTION_TYPE)

    // Validate type is required
    if (!type) {
      throw GetSuggestionsAssistantError.createMissingType()
    }

    // Validate type is valid
    if (!validTypes.includes(type)) {
      throw GetSuggestionsAssistantError.createInvalidType({type, validTypes})
    }

    // Validate adId is required when type is AD_DETAIL
    if (type === NET_SUGGESTION_TYPE.AD_DETAIL && !adId) {
      throw GetSuggestionsAssistantError.createMissingAdId({type})
    }

    return new GetSuggestionsAssistantRequest({type, chatId, adId})
  }

  get type() {
    return this.#type
  }

  get chatId() {
    return this.#chatId
  }

  get adId() {
    return this.#adId
  }

  get value() {
    return {
      type: this.#type,
      chatId: this.#chatId,
      adId: this.#adId
    }
  }

  getPayload() {
    return {
      chatId: this.#chatId,
      page: {
        type: this.#type,
        adId: this.#adId
      }
    }
  }

  toJSON() {
    return {
      type: this.#type,
      chatId: this.#chatId,
      adId: this.#adId
    }
  }
}
